<template>
  <div class="sidebar">
    <img class="avatar" :src="artistAvatar" v-if="artistMode && isArtist">
    <img class="avatar" :src="avatarImage" v-else>

    <b-dropdown size="sm" :text="displayName" class="artist-dropdown" v-if="isArtist">
      <b-dropdown-item :to="{name: 'fan-home'}">Browse as fan</b-dropdown-item>
      <b-dropdown-item :to="{name: 'artist-dashboard'}">Artist studio</b-dropdown-item>
    </b-dropdown>

    <div class="fan-name" v-if="!isArtist">
      {{ displayName }}
    </div>

    <hr>

    <router-link class="counter" v-if="artistMode" :to="{name: 'artist-followers'}">
      {{ followerCount }}
    </router-link>
    <router-link class="counter" v-if="!artistMode" :to="{name: 'fan-followed-artists'}">
      Following {{ followedArtists.length }}
    </router-link>

    <NavLinks :artist="artistMode && isArtist" class="padded"></NavLinks>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .sidebar {
    display: none;
    /* width: 10em; */
    flex: 0;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    justify-items: top;
    z-index: 2;
    flex-basis: 11.5em;
    /* flex-basis: 254px; */
    background-image: linear-gradient(to bottom, $dark-three, $dark-four 400px);
    box-shadow: 0 2px 23px 0 rgba(0, 0, 0, 0.5);
    text-align: center;
    padding-top: 1em;
    padding-bottom: 2em;
    margin-bottom: -20px;

    @include media-breakpoint-up(lg) {
      display: flex;
    }

    .avatar {
      width: 8.2em;
      height: 8.2em;
      border-radius: 100%;
      margin: 1em;
    }

    .fan-name {
      font-size: 0.9em;
    }

    .artist-dropdown /deep/ {
      .dropdown-toggle {
        margin: 5px;
        white-space: normal;
        background: transparent;
        color: $body-color;
        border: 0;
      }

      .dropdown-menu.show {
        background-color: #343459;
        font-size: 0.8em;
        box-shadow: 7px 2px 9px 0 rgba(0, 0, 0, 0.6);
      }

      .dropdown-item {
        background: transparent;
        color: $steel;

        &:focus {
          outline: none;
        }

        &:hover {
          color: $white;
        }
      }

    }

    hr {
      margin: 0.5em;
      border: 1px solid white;
      width: 4em;
    }

    .counter {
      font-size: 0.8em;
      color: $white;
    }
  }
</style>

<script>
import { mapGetters } from 'vuex'

import NavLinks from './NavLinks'

export default {
  name: 'Sidebar',
  props: ['artistMode'],
  components: {
    NavLinks
  },
  computed: {
    ...mapGetters('profile', ['currentUser', 'isArtist', 'avatarImage', 'followedArtists']),
    ...mapGetters('artist', ['artist', 'artistAvatar']),
    displayName () {
      return (this.isArtist && this.artistMode) ? this.artist.name : this.$store.getters['profile/displayName']
    },
    followerCount () {
      const count = this.artist.follower_count || 0
      return `${count} Follower` + ((count === 1) ? '' : 's')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/Sidebar.vue